export class AwsNativeHighFrequencyBackupPolicyPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<HighFrequencyBackupResourceType>",
            "format": ""
        },
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<AwsNativeHighFrequencyBackupSchedules>",
            "format": ""
        },
        {
            "name": "scheduleTimezone",
            "baseName": "scheduleTimezone",
            "type": "ScheduleTimezone",
            "format": ""
        },
        {
            "name": "vaultProtectionMode",
            "baseName": "vaultProtectionMode",
            "type": "VaultProtectionMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsNativeHighFrequencyBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
